import { PayoutType } from "@daytrip/legacy-enums";
export { PayoutType };

export const PayoutTypes = Object.keys(PayoutType)
    .filter((key: string) => !isNaN(Number(key)))
    .map((i: string) => Number(i)) as Array<PayoutType>;
